import { render, staticRenderFns } from "./ChangePersonalData.vue?vue&type=template&id=2e331715&scoped=true&"
import script from "./ChangePersonalData.vue?vue&type=script&lang=ts&"
export * from "./ChangePersonalData.vue?vue&type=script&lang=ts&"
import style0 from "./ChangePersonalData.vue?vue&type=style&index=0&id=2e331715&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e331715",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow,VTextField})
